/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, act } from 'react';
import style from './UserManage.module.css';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Table, Input, Pagination, Space, Dropdown, Checkbox, Tag, message } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { CiMenuKebab, CiFilter, CiSearch } from 'react-icons/ci';
import Button from '../../components/Basic/button';
import FormModal from '../../components/Modal/FormModal';
import ResetPasswordModal from '../../components/Modal/ResetPasswordModal';
import Features from '../../Forms/UserForm.';
import Header from '../../components/Header/header';
import { connect } from 'react-redux';
import * as Actions from "../../store/slices/user/user"
import { hasAnyPermission, hasPermission } from '../../utils/premission';
import { PERMISSIONS } from '../../utils/constant/permissions';
import { useNavigate } from 'react-router-dom';

interface Api {
    User_Red: any;
    getAllUser: (payload: any) => void;
    unlockUser: (id: number) => Promise<any>;
    resetPassword: (id: number, newPassword: string) => Promise<any>;
    approveUser: (id: number) => Promise<any>;
    rejectUser: (id: number) => Promise<any>;
    deleteUser: (id: number) => Promise<any>;
}

interface DataSource {
    key: string;
    UserName: string;
    Role: string;
    email: string;
    PhoneNumber: string;
    StartDate: string;
    EndDate: string;
    createdByUser: string;
    approvedByUser: string;
}

const MultiViewTable: React.FC<Api> = ({ getAllUser, unlockUser, resetPassword, approveUser, rejectUser, deleteUser, User_Red }) => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchText, setSearchText] = useState<string>('');
    const [selectedColumns, setSelectedColumns] = useState<string[]>(['UserName', 'Role', 'email', 'active', 'lastSuccessLoginAt', 'lastLoginAttemptAt', 'locked', 'createdByUser', 'approvedByUser']);
    const [loadingText, setLoadingText] = useState<boolean>(true)
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [open, setOpen] = useState(false);
    const [openUnlock, setOpenUnlock] = useState(false);
    const [openResetPassword, setOpenResetPassword] = useState(false);
    const [openApprove, setOpenApprove] = useState(false);
    const [openReject, setOpenReject] = useState(false);
    const [showForm, setShowForm] = useState<boolean>(false);
    const [modalText, setModalText] = useState<string>('')
    const [selectedUserId, setSelectedUserId] = useState<number | undefined>(undefined);
    const [selectedDeleteId, setSelectedDeleteId] = useState<number | null>(null);
    const [selectedUnlockId, setSelectedUnlockId] = useState<number | null>(null);
    const [selectedResetPasswordId, setSelectedResetPasswordId] = useState<number | null>(null);
    const [selectedApproveId, setSelectedApproveId] = useState<number | null>(null);
    const [selectedRejectId, setSelectedRejectId] = useState<number | null>(null);
    const [selectedUserName, setSelectedUserName] = useState<string>('');

    useEffect(() => {
        getAllUser({
            page: currentPage - 1,
            size: pageSize,
            search: searchText.trim() || undefined,

        });
    }, [currentPage, pageSize, searchText, getAllUser]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchText]);



    const onSearch = (value: string) => setSearchText(value.toLowerCase());

    const handleCheckboxChange = (checked: boolean, column: string) => {
        setSelectedColumns((prevSelected) =>
            checked ? [...prevSelected, column] : prevSelected.filter((col) => col !== column)
        );
    };

    const apiUsers = User_Red?.data?.content || [];

    useEffect(() => {
        if (User_Red?.dataSingle?.[0]?.res?.status === '1004') {
            message.error(User_Red.dataSingle[0].res.message);
            localStorage.clear();
            navigate('/');
        } else if (User_Red?.dataSingle?.[0]?.res?.status === '1005') {
            message.warning(User_Red.dataSingle[0].res.message);
        }
    }, [User_Red, navigate]);


    const dataSource = apiUsers.map((user: any, index: number) => ({
        key: user.userId.toString(),
        userId: user.userId,
        email: user.email || '-',
        active: String(user.active) === 'true' ? 'Active' : 'Inactive',
        UserName: user.userName || '-',
        Role: user.roles?.join(', ') || '-',
        lastSuccessLoginAt: user.lastSuccessLoginAt || '-',
        lastLoginAttemptAt: user.lastLoginAttemptAt || '-',
        locked: user.locked || "-",
        createdByUser: user.createdByUser || '-',
        approvedByUser: user.approvedByUser || '-',
    }));

    const createHandle = () => {
        setSelectedUserId(undefined);
        setShowForm(true);
    };

    const formatDateTime = (value: any) => {
        if (!value) return '-';
        try {
            const d = new Date(value);
            if (isNaN(d.getTime())) return String(value);
            return d.toLocaleString();
        } catch (e) {
            return String(value);
        }
    };

    const calcSessionDuration = (login: any, logout: any) => {
        if (!login || !logout) return '-';
        try {
            const a = new Date(login);
            const b = new Date(logout);
            if (isNaN(a.getTime()) || isNaN(b.getTime())) return '-';
            let diff = Math.abs(b.getTime() - a.getTime());
            const hours = Math.floor(diff / (1000 * 60 * 60));
            diff -= hours * 1000 * 60 * 60;
            const minutes = Math.floor(diff / (1000 * 60));
            return `${hours}h ${minutes}m`;
        } catch (e) {
            return '-';
        }
    };

    const fetchAllFromApi = async (url: string): Promise<any[]> => {
        const token = localStorage.getItem('loginToken');
        const size = 1000;
        let page = 0;
        let allData: any[] = [];
        while (true) {
            const res = await fetch(`${process.env.REACT_APP_API_URL}${url}?page=${page}&size=${size}`, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
            });
            if (!res.ok) break;
            const json = await res.json();
            // API returns a plain array directly
            const content = Array.isArray(json) ? json : (json?.content ?? json?.data?.content ?? json?.data ?? []);
            if (!Array.isArray(content) || content.length === 0) break;
            allData = [...allData, ...content];
            if (content.length < size) break;
            page++;
        }
        return allData;
    };

    const downloadActiveUsersReport = async () => {
        try {
            setButtonLoading(true);
            const users = await fetchAllFromApi('/api/users/is-active/true');

            const doc = new jsPDF('p', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            doc.setFontSize(20);
            doc.setTextColor('#1a73e8');
            doc.text('User Management Report', pageWidth / 2, 50, { align: 'center' });
            doc.setFontSize(16);
            doc.setTextColor('#000000');
            doc.text('Active Users Report', 40, 80);

            const head = [['User Name', 'Role', 'Email Address', 'Active', 'Last Success Login', 'Last Login Attempt', 'Failed Attempts', 'Locked', 'Created At']];
            const body = users.map((u: any) => [
                u.userName || '-',
                Array.isArray(u.roles) ? u.roles.join(', ') : '-',
                u.email || '-',
                u.active === true ? 'Active' : 'Inactive',
                formatDateTime(u.lastSuccessLoginAt),
                formatDateTime(u.lastLoginAttemptAt),
                u.failedLoginAttempt ?? 0,
                u.locked === true ? 'Locked' : 'Unlocked',
                formatDateTime(u.createdAt),
            ]);

            (autoTable as any)(doc, {
                startY: 110, head, body,
                styles: { fontSize: 10, cellPadding: 6 },
                headStyles: { fillColor: [10, 87, 185], textColor: 255 },
                theme: 'grid', margin: { left: 40, right: 40 },
            });
            doc.save('active-users-report.pdf');
        } catch (error: any) {
            console.error('Export PDF failed', error);
            message.error('Failed to generate active users report');
        } finally {
            setButtonLoading(false);
        }
    };

    const downloadInactiveUsersReport = async () => {
        try {
            setButtonLoading(true);
            const users = await fetchAllFromApi('/api/users/is-active/false');

            const doc = new jsPDF('p', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            doc.setFontSize(20);
            doc.setTextColor('#1a73e8');
            doc.text('User Management Report', pageWidth / 2, 50, { align: 'center' });
            doc.setFontSize(16);
            doc.setTextColor('#000000');
            doc.text('Inactive Users Report', 40, 80);

            const head = [['User Name', 'Role', 'Email Address', 'Active', 'Last Success Login', 'Last Login Attempt', 'Failed Attempts', 'Locked', 'Created At']];
            const body = users.map((u: any) => [
                u.userName || '-',
                Array.isArray(u.roles) ? u.roles.join(', ') : '-',
                u.email || '-',
                u.active === true ? 'Active' : 'Inactive',
                formatDateTime(u.lastSuccessLoginAt),
                formatDateTime(u.lastLoginAttemptAt),
                u.failedLoginAttempt ?? 0,
                u.locked === true ? 'Locked' : 'Unlocked',
                formatDateTime(u.createdAt),
            ]);

            (autoTable as any)(doc, {
                startY: 110, head, body,
                styles: { fontSize: 10, cellPadding: 6 },
                headStyles: { fillColor: [10, 87, 185], textColor: 255 },
                theme: 'grid', margin: { left: 40, right: 40 },
            });
            doc.save('inactive-users-report.pdf');
        } catch (error: any) {
            console.error('Export PDF failed', error);
            message.error('Failed to generate inactive users report');
        } finally {
            setButtonLoading(false);
        }
    };

    const downloadLastLoginReport = async () => {
        try {
            setButtonLoading(true);
            const users = await fetchAllFromApi('/api/users/last-success-login');

            const doc = new jsPDF('p', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            doc.setFontSize(20);
            doc.setTextColor('#1a73e8');
            doc.text('User Management Report', pageWidth / 2, 50, { align: 'center' });
            doc.setFontSize(16);
            doc.setTextColor('#000000');
            doc.text('Users Last Login Report', 40, 80);

            const head = [['User Name', 'Role', 'Email Address', 'Active', 'Last Success Login', 'Last Login Attempt', 'Failed Attempts', 'Created At']];
            const body = users.map((u: any) => [
                u.userName || '-',
                Array.isArray(u.roles) ? u.roles.join(', ') : '-',
                u.email || '-',
                u.active === true ? 'Active' : 'Inactive',
                formatDateTime(u.lastSuccessLoginAt),
                formatDateTime(u.lastLoginAttemptAt),
                u.failedLoginAttempt ?? 0,
                formatDateTime(u.createdAt),
            ]);

            (autoTable as any)(doc, {
                startY: 110, head, body,
                styles: { fontSize: 10, cellPadding: 6 },
                headStyles: { fillColor: [10, 87, 185], textColor: 255 },
                theme: 'grid', margin: { left: 40, right: 40 },
            });
            doc.save('last-login-report.pdf');
        } catch (error: any) {
            console.error('Export PDF failed', error);
            message.error('Failed to generate last login report');
        } finally {
            setButtonLoading(false);
        }
    };




    const editHandle = (record: any) => {
        setSelectedUserId(record.userId);
        setShowForm(true);
    };

    const backHandle = () => {
        setShowForm(false);
        setSelectedUserId(undefined);
        getAllUser({ page: currentPage - 1, size: pageSize, search: searchText.trim() || undefined });
    };

    const deleteHandle = (record: any) => {
        setSelectedDeleteId(record.userId);
        setModalText('Are you sure you want to delete this record?');
        setOpen(true);
    };

    const confirmDelete = async () => {
        if (!selectedDeleteId) return;
        setButtonLoading(true);
        try {
            const result = await deleteUser(selectedDeleteId);
            if (result?.success) {
                message.success(result.message || 'User deleted successfully');
                getAllUser({ page: currentPage - 1, size: pageSize });
            } else {
                message.error(result?.message || 'Failed to delete user');
            }
        } catch (error: any) {
            message.error(error?.message || 'An unexpected error occurred');
        } finally {
            setButtonLoading(false);
            setOpen(false);
            setSelectedDeleteId(null);
        }
    };

    const unlockHandle = (record: any) => {
        setSelectedUnlockId(record.userId);
        setModalText('Unlock this user?');
        setOpenUnlock(true);
    };

    const resetPasswordHandle = (record: any) => {
        setSelectedResetPasswordId(record.userId);
        setSelectedUserName(record.UserName);
        setOpenResetPassword(true);
    };

    const approveHandle = (record: any) => {
        setSelectedApproveId(record.userId);
        setModalText('Approve this user?');
        setOpenApprove(true);
    };

    const rejectHandle = (record: any) => {
        setSelectedRejectId(record.userId);
        setModalText('Reject this user?');
        setOpenReject(true);
    };

    const confirmUnlock = async () => {
        if (!selectedUnlockId) return;

        setButtonLoading(true);

        try {
            const result = await unlockUser(selectedUnlockId);

            if (result?.success) {
                message.success(result.message || 'User unlocked successfully');
                getAllUser({ page: currentPage - 1, size: pageSize });
            } else {
                message.error(result?.exceptionMsg || result?.message);
            }
        } catch (error: any) {
            console.error('Unlock user error:', error);
            message.error(error?.message || 'An unexpected error occurred while unlocking the user');
        } finally {
            setButtonLoading(false);
            setOpenUnlock(false);
            setSelectedUnlockId(null);
        }
    };

    const confirmApprove = async () => {
        if (!selectedApproveId) return;

        setButtonLoading(true);
        try {
            const result = await approveUser(selectedApproveId);
            if (result?.success) {
                message.success(result.message || 'User approved successfully');
                getAllUser({ page: currentPage - 1, size: pageSize });
            } else {
                message.error(result?.message);
            }
        } catch (error: any) {
            console.error('Approve user error:', error);
            message.error(error?.message || 'An unexpected error occurred while approving the user');
        } finally {
            setButtonLoading(false);
            setOpenApprove(false);
            setSelectedApproveId(null);
        }
    };

    const confirmReject = async () => {
        if (!selectedRejectId) return;

        setButtonLoading(true);
        try {
            const result = await rejectUser(selectedRejectId);
            if (result?.success) {
                message.success(result.message || 'User rejected successfully');
                getAllUser({ page: currentPage - 1, size: pageSize });
            } else {
                message.error(result?.message);
            }
        } catch (error: any) {
            console.error('Reject user error:', error);
            message.error(error?.message || 'An unexpected error occurred while rejecting the user');
        } finally {
            setButtonLoading(false);
            setOpenReject(false);
            setSelectedRejectId(null);
        }
    };

    const confirmResetPassword = async (newPassword: string) => {
        if (!selectedResetPasswordId) return;

        try {
            const result = await resetPassword(selectedResetPasswordId, newPassword);

            if (result?.success) {
                message.success(result.message || 'Password reset successfully');
                setOpenResetPassword(false);
                setSelectedResetPasswordId(null);
                setSelectedUserName('');
            } else {
                message.error(result?.message || 'Failed to reset password');
            }
        } catch (error: any) {
            console.error('Reset password error:', error);
            message.error(error?.message || 'An unexpected error occurred');
        }
    };

    const actionMenu = (record: any) => (
        <Space direction="vertical" className={style.actions}>
            {hasPermission(PERMISSIONS.USER_UPDATE) && (
                <div className={style.dropdownItem} onClick={() => editHandle(record)}>Edit</div>
            )}
            {hasPermission(PERMISSIONS.USER_DELETE) && (
                <div className={style.dropdownItem} onClick={() => deleteHandle(record)}>Delete</div>
            )}
            {hasPermission(PERMISSIONS.USER_UNLOCK) && (
                <div className={style.dropdownItem} onClick={() => unlockHandle(record)}>Unlock</div>
            )}
            {hasPermission(PERMISSIONS.USER_RESET_PASSWORD) && (
                <div className={style.dropdownItem} onClick={() => resetPasswordHandle(record)}>Reset Password</div>
            )}
            {hasPermission(PERMISSIONS.USER_APPROVE) && (
                <div className={style.dropdownItem} onClick={() => approveHandle(record)}>Approve</div>
            )}
            {hasPermission(PERMISSIONS.USER_REJECT) && (
                <div className={style.dropdownItem} onClick={() => rejectHandle(record)}>Reject</div>
            )}
        </Space>
    );

    const allColumns = [
        {
            title: 'User Name',
            dataIndex: 'UserName',
            key: 'UserName',
            width: 150,
            sorter: (a: DataSource, b: DataSource) => a.UserName.localeCompare(b.UserName),
        },
        {
            title: 'Role',
            dataIndex: 'Role',
            key: 'Role',
            width: 120,
            sorter: (a: DataSource, b: DataSource) => a.Role.localeCompare(b.Role),
        },
        {
            title: 'Email Address',
            dataIndex: 'email',
            key: 'email',
            width: 200,
        },
        {
            title: 'Last Login At',
            dataIndex: 'lastSuccessLoginAt',
            key: 'lastSuccessLoginAt',
            width: 100,
            sorter: (a: any, b: any) => a.lastSuccessLoginAt.localeCompare(b.lastSuccessLoginAt),
        },
        {
            title: 'Last Login Attempt',
            dataIndex: 'lastLoginAttemptAt',
            key: 'lastLoginAttemptAt',
            width: 100,
            sorter: (a: any, b: any) => a.lastLoginAttemptAt.localeCompare(b.lastLoginAttemptAt),
        },
        {
            title: 'Active',
            dataIndex: 'active',
            key: 'active',
            width: 100,
            render: (active: any) => {
                const isActive = active === 'Active';
                console.log(isActive)
                return (
                    <Tag color={isActive ? 'green' : 'orange'}>
                        {active}
                    </Tag>
                );
            },
        },

        {
            title: 'Status',
            dataIndex: 'locked',
            key: 'locked',
            width: 100,
            render: (locked: any) => {
                const isLocked = locked === true || locked === 'true' || locked === 1 || locked === '1';
                return (
                    <Tag color={isLocked ? 'red' : 'green'}>
                        {isLocked ? 'Locked' : 'Unlocked'}
                    </Tag>
                );
            },
        },
        {
            title: 'Created By User',
            dataIndex: 'createdByUser',
            key: 'createdByUser',
            width: 130,
        },
        {
            title: 'Approved By User',
            dataIndex: 'approvedByUser',
            key: 'approvedByUser',
            width: 130,
        },
        {
            title: 'Action',
            key: 'action',
            fixed: 'right' as const,
            width: 50,
            render: (text: any, record: any) => (

                <Dropdown
                    overlay={() => actionMenu(record)}
                    trigger={['click']}
                    placement="bottomRight"
                >
                    <CiMenuKebab className={style.actionIcon} />
                </Dropdown>
            ),
        },
    ];





    const filteredColumns = allColumns.filter((col: any) => selectedColumns.includes(col.key) || col.key === 'action');

    const filteredData = dataSource.filter((item: any) =>
        item.Role.toLowerCase().includes(searchText) ||
        item.UserName.toLowerCase().includes(searchText) ||
        (item.lastSuccessLoginAt && item.lastSuccessLoginAt.toLowerCase().includes(searchText)) ||
        (item.lastLoginAttemptAt && item.lastLoginAttemptAt.toLowerCase().includes(searchText)) ||
        (item.createdByUser && item.createdByUser.toLowerCase().includes(searchText)) ||
        (item.approvedByUser && item.approvedByUser.toLowerCase().includes(searchText))
    );




    const items = [
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('UserName')}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'UserName')}
                >
                    User Name
                </Checkbox>
            ),
            key: '2',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('Role')}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'Role')}
                >
                    Role
                </Checkbox>
            ),
            key: '1',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('email')}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'email')}
                >
                    Email Address
                </Checkbox>
            ),
            key: '3',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('active')}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'active')}
                >
                    Active
                </Checkbox>
            ),
            key: '4',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('lastSuccessLoginAt')}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'lastSuccessLoginAt')}
                >
                    Last Login At
                </Checkbox>
            ),
            key: '5',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('lastLoginAttemptAt')}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'lastLoginAttemptAt')}
                >
                    Last Login Attempt
                </Checkbox>
            ),
            key: '6',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('locked')}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'locked')}
                >
                    Status
                </Checkbox>
            ),
            key: '7',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('createdByUser')}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'createdByUser')}
                >
                    Created By User
                </Checkbox>
            ),
            key: '8',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('approvedByUser')}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'approvedByUser')}
                >
                    Approved By User
                </Checkbox>
            ),
            key: '9',
        },
    ];

    useEffect(() => {
        setLoadingText(true)
        setTimeout(() => {
            setLoadingText(false)
        }, 2000)
    }, [])



    return (
        <>


            <Header />
            <FormModal modalTitle={modalText} Subtitle={''} open={open} setOpen={setOpen} onOk={confirmDelete} onCancel={() => setOpen(false)} okText="Delete" cancelText="Cancel" />
            <FormModal modalTitle={modalText} Subtitle={''} open={openUnlock} setOpen={setOpenUnlock} onOk={confirmUnlock} onCancel={() => setOpenUnlock(false)} okText="Unlock" cancelText="Cancel" />
            <FormModal modalTitle={modalText} Subtitle={''} open={openApprove} setOpen={setOpenApprove} onOk={confirmApprove} onCancel={() => setOpenApprove(false)} okText="Approve" cancelText="Cancel" />
            <FormModal modalTitle={modalText} Subtitle={''} open={openReject} setOpen={setOpenReject} onOk={confirmReject} onCancel={() => setOpenReject(false)} okText="Reject" cancelText="Cancel" />
            <ResetPasswordModal open={openResetPassword} onOk={confirmResetPassword} onCancel={() => setOpenResetPassword(false)} userName={selectedUserName} />
            {showForm ? (
                <Features Back={backHandle} userId={selectedUserId} />
            ) : (
                <>
                    <div className={style.Route}>
                        <h5>User Management</h5>
                        <div className={style.btns}>
                            {hasPermission(PERMISSIONS.USER_CREATE) && (
                                <Button Text={'Create User'} buttonClass={style.createBtn} onClick={createHandle} Disable={loadingText} />
                            )}

                        </div>
                    </div>
                    <div className={style.container}>
                        <Space className={style.SearchTable}>
                            <div className={style.SearchBar}>
                                <Input
                                    placeholder="Search..."
                                    prefix={<CiSearch size={20} />}
                                    onChange={(e) => onSearch(e.target.value)}
                                    style={{ width: 200 }}
                                    className={style.inputSearch}
                                />
                                <Dropdown
                                    menu={{ items }}
                                    trigger={['click']}
                                >
                                    <SettingOutlined className={style.tableSettings} />
                                </Dropdown>
                            </div>
                            <div className={style.reportButtons}>
                                {hasPermission(PERMISSIONS.USER_VIEW) && (
                                    <>
                                <Button Disable={false} Text={'Download Active Users Report'} buttonClass={style.createBtn} onClick={downloadActiveUsersReport} />
                                <Button Disable={false} Text={'Download Inactive Users Report'} buttonClass={style.createBtn} onClick={downloadInactiveUsersReport} />
                                <Button Disable={false} Text={'Download Last Login Report'} buttonClass={style.createBtn} onClick={downloadLastLoginReport} />
                                </>
                                )}
                            </div>
                        </Space>
                        <Table
                            loading={User_Red?.loading || loadingText}
                            columns={filteredColumns}
                            dataSource={filteredData}
                            pagination={false}
                            rowSelection={{
                                type: 'checkbox',
                            }}
                            size="small"
                            onChange={(pagination, filters, sorter) => {
                                if (!Array.isArray(sorter)) {
                                    console.log('Field:', sorter.field);
                                    console.log('Order:', sorter.order);
                                }
                            }}
                        />
                        <Pagination
                            align="end"
                            showTotal={(total) => `Total ${total} items`}
                            current={currentPage}
                            total={User_Red?.data?.totalElements || 0}
                            pageSize={pageSize}
                            pageSizeOptions={[10, 20, 50, 100]}
                            showSizeChanger
                            onChange={(page, newSize) => {
                                setCurrentPage(page);
                                if (newSize !== pageSize) {
                                    setPageSize(newSize);
                                    setCurrentPage(1);
                                }
                            }}
                            style={{ marginTop: 16 }}
                        />
                    </div>
                </>
            )}
        </>
    );
};

function mapStateToProps(state: any) {
    return {
        User_Red: state.User_Red
    }
}

export default connect(mapStateToProps, Actions)(MultiViewTable)